/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelTipoPraticaRegolaPunteggioCategoriaDTO } from '../model/models';
import { TipoPraticaRegolaPunteggioCategoriaCreationForm } from '../model/models';
import { TipoPraticaRegolaPunteggioCategoriaDTO } from '../model/models';
import { TipoPraticaRegolaPunteggioCategoriaPatchForm } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CreateTipoPraticaRegolaPunteggioCategoriaRequestParams {
    idTipoPratica: string;
    tipoPraticaRegolaPunteggioCategoriaCreationForm: TipoPraticaRegolaPunteggioCategoriaCreationForm;
}

export interface DeleteTipoPraticaRegolaPunteggioCategoriaRequestParams {
    idTipoPratica: string;
    idCategoria: string;
}

export interface GetTipoPraticaRegolaPunteggioCategoriaRequestParams {
    idTipoPratica: string;
    idCategoria: string;
}

export interface ListTipoPraticaRegolePunteggioCategorieRequestParams {
    idTipoPratica: string;
    pageable: Pageable;
}

export interface UpdateTipoPraticaRegolaPunteggioCategoriaRequestParams {
    idTipoPratica: string;
    idCategoria: string;
    tipoPraticaRegolaPunteggioCategoriaPatchForm: TipoPraticaRegolaPunteggioCategoriaPatchForm;
}


export interface TipoPraticaRegolaPunteggioCategoriaControllerServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Crea una nuova categoria di regole di punteggio
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie
* @param requestParameters
     */
    createTipoPraticaRegolaPunteggioCategoria(requestParameters: CreateTipoPraticaRegolaPunteggioCategoriaRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaRegolaPunteggioCategoriaDTO>;

    /**
     * Elimina una categoria di regole di punteggio (cascade su regole/predicati/fasce)
     * 
     * @endpoint delete /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}
* @param requestParameters
     */
    deleteTipoPraticaRegolaPunteggioCategoria(requestParameters: DeleteTipoPraticaRegolaPunteggioCategoriaRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Dettaglio di una categoria di regole di punteggio
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}
* @param requestParameters
     */
    getTipoPraticaRegolaPunteggioCategoria(requestParameters: GetTipoPraticaRegolaPunteggioCategoriaRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaRegolaPunteggioCategoriaDTO>;

    /**
     * Lista paginata delle categorie di regole di punteggio del bando
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie
* @param requestParameters
     */
    listTipoPraticaRegolePunteggioCategorie(requestParameters: ListTipoPraticaRegolePunteggioCategorieRequestParams, extraHttpRequestParams?: any): Observable<PagedModelTipoPraticaRegolaPunteggioCategoriaDTO>;

    /**
     * Replace di una categoria di regole di punteggio (richiede version)
     * 
     * @endpoint put /api/v1/gestione/tipi-pratica/{idTipoPratica}/regola-punteggio-categorie/{idCategoria}
* @param requestParameters
     */
    updateTipoPraticaRegolaPunteggioCategoria(requestParameters: UpdateTipoPraticaRegolaPunteggioCategoriaRequestParams, extraHttpRequestParams?: any): Observable<TipoPraticaRegolaPunteggioCategoriaDTO>;

}
